/* Lunaroza — comportamiento propio. Sin librerías externas. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Marca el documento: el CSS solo oculta los elementos para animarlos
     cuando este archivo se ha ejecutado de verdad. */
  document.documentElement.classList.add('lr-js');

  /* Red de seguridad: si a los 2,5 s hay algo pendiente que YA está en
     pantalla, se muestra sin esperar al observador. Lo que sigue estando
     fuera de la vista conserva su animación de entrada al hacer scroll. */
  window.setTimeout(function () {
    var pendientes = document.querySelectorAll('.lr-reveal:not(.lr-visible)');
    var alto = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < pendientes.length; i++) {
      var caja = pendientes[i].getBoundingClientRect();
      if (caja.top < alto && caja.bottom > 0) pendientes[i].classList.add('lr-visible');
    }
  }, 2500);

  /* --- Animaciones de entrada al hacer scroll --------------------------- */
  function initReveals() {
    var items = document.querySelectorAll('.lr-reveal:not(.lr-visible)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('lr-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('lr-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    for (var j = 0; j < items.length; j++) observer.observe(items[j]);
  }

  /* --- Cifras animadas -------------------------------------------------- */
  function initCounters() {
    var nums = document.querySelectorAll('[data-lr-count]');
    if (!nums.length) return;

    function run(el) {
      var target = parseFloat(el.getAttribute('data-lr-count'));
      var decimals = (el.getAttribute('data-lr-decimals') || '0') | 0;
      var prefix = el.getAttribute('data-lr-prefix') || '';
      var suffix = el.getAttribute('data-lr-suffix') || '';
      if (isNaN(target)) return;

      if (reduceMotion) {
        el.textContent = prefix + target.toFixed(decimals) + suffix;
        return;
      }

      var duration = 1500;
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < nums.length; i++) run(nums[i]);
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        run(entry.target);
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.5 });

    for (var k = 0; k < nums.length; k++) obs.observe(nums[k]);
  }

  /* --- Acordeones (FAQ y detalles del producto) ------------------------- */
  function initAccordions() {
    var buttons = document.querySelectorAll('[data-lr-acc-q]');
    if (!buttons.length) return;

    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.dataset.lrAccBound === '1') return;
      btn.dataset.lrAccBound = '1';

      btn.addEventListener('click', function () {
        var item = btn.closest('[data-lr-acc-item]');
        if (!item) return;
        var panel = item.querySelector('[data-lr-acc-a]');
        if (!panel) return;

        var isOpen = item.classList.contains('is-open');
        var group = item.closest('[data-lr-acc-group]');

        if (group && !isOpen) {
          Array.prototype.forEach.call(group.querySelectorAll('[data-lr-acc-item].is-open'), function (other) {
            other.classList.remove('is-open');
            var op = other.querySelector('[data-lr-acc-a]');
            if (op) op.style.maxHeight = '0px';
            var ob = other.querySelector('[data-lr-acc-q]');
            if (ob) ob.setAttribute('aria-expanded', 'false');
          });
        }

        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
        panel.style.maxHeight = isOpen ? '0px' : panel.scrollHeight + 'px';
      });
    });

    window.addEventListener('resize', function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-lr-acc-item].is-open'), function (item) {
        var panel = item.querySelector('[data-lr-acc-a]');
        if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
      });
    });
  }

  /* --- Galería del producto --------------------------------------------- */
  function initGallery() {
    var galleries = document.querySelectorAll('[data-lr-gallery]');
    if (!galleries.length) return;

    Array.prototype.forEach.call(galleries, function (gallery) {
      var main = gallery.querySelector('[data-lr-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-lr-gallery-thumb]');
      if (!main || !thumbs.length) return;

      Array.prototype.forEach.call(thumbs, function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var alt = thumb.getAttribute('data-alt') || '';
          if (!src) return;
          main.setAttribute('src', src);
          main.setAttribute('alt', alt);
          Array.prototype.forEach.call(thumbs, function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* --- Selector de variantes -------------------------------------------- */
  function initVariants() {
    var forms = document.querySelectorAll('[data-lr-variants]');
    if (!forms.length) return;

    Array.prototype.forEach.call(forms, function (root) {
      var dataEl = root.querySelector('[data-lr-variant-data]');
      var idInput = root.querySelector('[data-lr-variant-id]');
      var priceEl = root.querySelector('[data-lr-price]');
      var compareEl = root.querySelector('[data-lr-compare]');
      var submitEl = root.querySelector('[data-lr-submit]');
      var soldEl = root.querySelector('[data-lr-sold]');
      var inputs = root.querySelectorAll('[data-lr-option]');
      if (!dataEl || !idInput || !inputs.length) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!variants || !variants.length) return;

      var soldOutText = root.getAttribute('data-sold-text') || 'Sold out';
      var addText = submitEl ? submitEl.getAttribute('data-add-text') || submitEl.textContent.trim() : '';

      function currentSelection() {
        var chosen = [];
        Array.prototype.forEach.call(inputs, function (input) {
          if (!input.checked) return;
          var pos = parseInt(input.getAttribute('data-option-position'), 10) - 1;
          chosen[pos] = input.value;
        });
        return chosen;
      }

      function update() {
        var chosen = currentSelection();
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var ok = true;
          for (var j = 0; j < chosen.length; j++) {
            if (chosen[j] !== undefined && v.options[j] !== chosen[j]) { ok = false; break; }
          }
          if (ok) { match = v; break; }
        }
        if (!match) return;

        idInput.value = match.id;

        if (priceEl && match.price_formatted) priceEl.innerHTML = match.price_formatted;
        if (compareEl) {
          if (match.compare_formatted) {
            compareEl.innerHTML = match.compare_formatted;
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        Array.prototype.forEach.call(root.querySelectorAll('[data-lr-option-name]'), function (el) {
          var pos = parseInt(el.getAttribute('data-lr-option-name'), 10) - 1;
          if (chosen[pos]) el.textContent = chosen[pos];
        });

        if (submitEl) {
          submitEl.disabled = !match.available;
          submitEl.textContent = match.available ? addText : soldOutText;
        }
        if (soldEl) soldEl.hidden = match.available;

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      Array.prototype.forEach.call(inputs, function (input) {
        input.addEventListener('change', update);
      });

      update();
    });
  }

  /* --- Duplicar el contenido de las marquesinas para bucle continuo ------ */
  function initMarquees() {
    var tracks = document.querySelectorAll('[data-lr-marquee]');
    if (!tracks.length) return;

    Array.prototype.forEach.call(tracks, function (track) {
      if (track.dataset.lrCloned === '1') return;
      track.dataset.lrCloned = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* --- Selector de packs (cantidad) ------------------------------------- */
  function initPacks() {
    var grupos = document.querySelectorAll('[data-lr-packs]');
    if (!grupos.length) return;

    Array.prototype.forEach.call(grupos, function (grupo) {
      var botones = grupo.querySelectorAll('[data-lr-pack]');
      if (!botones.length) return;

      var raiz = grupo.closest('[data-lr-variants]') || document;
      var campoCantidad = raiz.querySelector('[data-lr-cantidad]');
      if (!campoCantidad) return;

      /* Si ninguno viene marcado, marca el primero. */
      if (!grupo.querySelector('[data-lr-pack].is-active')) {
        botones[0].classList.add('is-active');
      }
      var activo = grupo.querySelector('[data-lr-pack].is-active');
      campoCantidad.value = activo.getAttribute('data-cantidad') || '1';

      Array.prototype.forEach.call(botones, function (boton) {
        if (boton.dataset.lrPackBound === '1') return;
        boton.dataset.lrPackBound = '1';

        boton.addEventListener('click', function () {
          Array.prototype.forEach.call(botones, function (b) { b.classList.remove('is-active'); });
          boton.classList.add('is-active');
          campoCantidad.value = boton.getAttribute('data-cantidad') || '1';
        });
      });
    });
  }

  /* --- Comparador antes/después ------------------------------------------ */
  function initComparador() {
    var marcos = document.querySelectorAll('[data-lr-compare]');
    if (!marcos.length) return;

    Array.prototype.forEach.call(marcos, function (marco) {
      var rango = marco.querySelector('[data-lr-compare-range]');
      if (!rango || marco.dataset.lrCompareBound === '1') return;
      marco.dataset.lrCompareBound = '1';

      function actualizar() {
        marco.style.setProperty('--lr-compare-pos', rango.value + '%');
      }

      rango.addEventListener('input', actualizar);
      actualizar();
    });
  }

  function init() {
    initMarquees();
    initReveals();
    initCounters();
    initAccordions();
    initGallery();
    initVariants();
    initPacks();
    initComparador();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* El editor de Shopify recarga secciones sueltas: reinicializa. */
  document.addEventListener('shopify:section:load', init);
})();
